import { useSelector } from 'react-redux';

import { useFeatureToggle } from '@flopflip/react-redux';

import { FeatureFlag } from 'constants/featureFlags';

import { selectIsCrmEnabledForCompany } from 'store/companies/selectors/crmFeatures.selectors';

/**
 * CRM availability for the current session: the environment feature flag AND the
 * master company's EnableCrm company property (absent property = enabled).
 *
 * The lead-stage routing gates (LoanApplicationPage, LeadWorkspacePage) intentionally
 * do NOT use this hook — they consult only selectIsCrmEnabledForCompany, because the
 * lead redirect never depended on the env feature flag.
 * @returns {Boolean}
 */
const useIsCrmEnabled = () => {
  const isCrmFeatureEnabled = useFeatureToggle(FeatureFlag.EnableCrm);
  const isCrmEnabledForCompany = useSelector(selectIsCrmEnabledForCompany);

  return isCrmFeatureEnabled && isCrmEnabledForCompany;
};

export default useIsCrmEnabled;
